import React from "react";

/*
Minimalist confirm dialog, styled to match the TicketNew theme (tn-modal-* in
TicketCaseDetail.css). Used before any action that writes to the ticket, e.g.
Advance/Revert stage in TicketCaseDetail.js.
*/
const ConfirmModal = function (props) {
  const { open, title, message, confirmLabel, cancelLabel, busy, onConfirm, onCancel } = props;

  if (!open) return null;

  return (
    <div className="tn-modal-overlay" onClick={onCancel}>
      <div
        className="tn-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={function (e) {
          e.stopPropagation();
        }}
      >
        <p className="tn-modal-title">{title}</p>
        {message ? <p className="tn-modal-body">{message}</p> : null}
        <div className="tn-modal-actions">
          <button
            type="button"
            className="tn-btn tn-btn-ghost tn-btn-sm"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel || "Cancel"}
          </button>
          <button
            type="button"
            className="tn-btn tn-btn-primary tn-btn-sm"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Working…" : confirmLabel || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
